import React, { useEffect, useState } from 'react';
import { NewsFilter } from './components/NewsFilter';
import { NewsListContainer } from './components/NewsListContainer/NewsListContainer';
import { getFiltersFromURL } from './components/NewsFilter/NewsFilter.helpers';
import { Accordion } from '@components/Accordion';
import './NewsList.scss';
import { useFetchNewsPageDataQuery, useLazyFetchNewsQuery } from './NewsList.service';
import { NewsList, NewsListFilter } from './NewsList.types';
import { LoadingSpinner } from '@components/LoadingSpinner';
import { useLoadMoreNews } from './NewsList.hooks';
import { useScrollPosition } from '@contexts/ScrollContext';

export const NewsListPage = () => {
  const [newsList, setNewsList] = useState<NewsList>({
    NewsListItems: [],
    HasNextPage: true,
  });
  const [page, setPage] = useState<number>(0);
  const { scrollHeight } = useScrollPosition();
  const [fetchNews, { isFetching: isLoadingNews, isUninitialized }] = useLazyFetchNewsQuery();
  const { data: newsPage, isLoading: isLoadingPage } = useFetchNewsPageDataQuery();

  useLoadMoreNews({
    scrollHeight,
    onLoadMore: () => setPage((page) => page + 1),
    isLoadingNews,
    hasNextPage: newsList?.HasNextPage,
  });

  const onSaveFilters = (filters: Omit<NewsListFilter, 'page'>) => {
    setPage(0);
    fetchNews({ ...filters, page: 0 }).then(({ data }) => setNewsList(data));
  };

  useEffect(() => {
    const filters = getFiltersFromURL();

    if (!isUninitialized && page === 0) return;
    // appending new items to the list
    fetchNews({ ...filters, page }).then(({ data }) => {
      setNewsList((prevNewsList) => ({
        ...data,
        NewsListItems: [...prevNewsList.NewsListItems, ...data?.NewsListItems],
      }));
    });
  }, [page]);

  return (
    <>
      {isLoadingPage && <LoadingSpinner />}
      {!isLoadingPage && (
        <section className='l-content l-page-center'>
          <div className='l-section l-section-main is-stretched'>
            <NewsListContainer
              isLoading={isLoadingNews}
              newsList={newsList}
              notFoundText={newsPage.I18n.ResultNotFound}
            />
          </div>
          <div className='l-section l-section-side l-order-first-mobile'>
            <Accordion.Container>
              <Accordion.Section
                tab={{
                  id: 1,
                  name: newsPage.I18n.NewsFilterTitle + ':',
                }}
                className='c-accordion-tabs-head-gray'
                isOpen={true}
                url={null}
              >
                <NewsFilter
                  i18n={newsPage.I18n}
                  categories={newsPage.CategoryList}
                  countriesList={newsPage.CountriesList}
                  industriesList={newsPage.IndustriesList}
                  onSaveFilter={onSaveFilters}
                  isLoadingNews={isLoadingNews}
                />
              </Accordion.Section>
            </Accordion.Container>

            {newsPage.ContentArea && (
              <div
                className='l-content hide-in-mobile content-area'
                dangerouslySetInnerHTML={{
                  __html: newsPage.ContentArea,
                }}
              />
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default NewsListPage;
